import { createFileRoute } from "@tanstack/react-router";
import { BillingTab } from "./settings.subscription";

export const Route = createFileRoute("/settings/subscription/billing")({
	component: BillingTab,
});
